import { useState } from 'react'

import { createMenuImageFormData } from 'utils/images'
import api from 'utils/api'

const useUploadMultipleImagesToS3 = () => {
  const [isLoading, setIsLoading] = useState(false)

  const uploadMultipleImagesToS3 = async (
    menuImages = {},
    orgName = ''
  ) => {
    setIsLoading(true)
    try {
      const promises = Object.entries(menuImages).map(
        ([key, value]) => {
          const imageFormData = createMenuImageFormData(
            value,
            key,
            orgName
          )
          return api.uploadImageToS3(imageFormData)
        }
      )

      const results = await Promise.allSettled(promises)
      return results
    } catch (error) {
      throw error
    } finally {
      setIsLoading(false)
    }
  }

  return { uploadMultipleImagesToS3, isLoading }
}

export default useUploadMultipleImagesToS3
